import { ERROR_CODES } from '@/shared/constants/errors.js'
import AuthController from '../domain/controller.js'
import { EVENTS } from '../utils/constants.js'
import saveUserInLocalData from './saveUserInLocalData.js'
import publishUserData from './publishUserData.js'
import createRiderIfMissing from './createRiderIfMissing.js'

async function makeSignup(context, payload) {
  console.log('🚀 ~ makeSignup ~ payload:', payload)
  const { events, networkRepo, localRepo, sendBugAlert } = context

  events.dispatch(EVENTS.APPLICATION_IS_WORKING)
  events.dispatch(EVENTS.SIGNUP_STARTED)

  let user = null

  try {
    user = await AuthController.register(payload, networkRepo, localRepo)
    console.log('🚀 ~ makeSignup ~ user:', user)

    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: `Signup successful ${user.firstName}`,
      body: 'Welcome! You can now access your personal space.',
    })
  } catch (error) {
    console.log('🚀 ~ makeSignup ~ error:', error)

    let title = 'Signup error'
    let body =
      'An error occurred. Please try again later or contact us if the problem persists.'

    switch (error?.code) {
      case ERROR_CODES.INVALID_INPUT:
        title = 'Invalid information'
        body =
          'The provided data is not valid. Please check your information and try again.'
        break

      case ERROR_CODES.CONFLICT:
        title = 'Email already used'
        body =
          'The email address you provided is already linked to an existing account. Please log in or use another address.'
        break

      case ERROR_CODES.SERVICE_UNAVAILABLE:
        title = 'Service temporarily unavailable'
        body =
          'Our servers are currently unreachable. Please try again in a few moments.'
        break

      case ERROR_CODES.SERVER_ERROR:
      default:
        title = 'Internal server error'
        body = 'An unexpected error occurred. Our teams have been notified.'
        sendBugAlert(error)
        break
    }

    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title,
      body,
      type: 'error',
    })
  }

  events.dispatch(EVENTS.SIGNUP_FINISHED)
  events.dispatch(EVENTS.APPLICATION_WORK_FINISHED)

  if (!user) return { success: false, user }
  await saveUserInLocalData(context)

  // Créer le rider sur l'API après le signup et sauvegarder le riderId
  try {
    const riderId = await createRiderIfMissing(context)
    if (riderId) {
      console.log('[makeSignup] Rider créé/lié avec succès, riderId:', riderId)
    } else {
      console.warn('[makeSignup] Le rider n\u2019a pas pu être créé (KYC probablement non approuvé - normal au signup initial)')
    }
  } catch (riderError) {
    console.error('[makeSignup] Erreur création rider (non bloquant):', riderError)
  }

  await publishUserData(context)
  context.events.dispatch(EVENTS.USER_CONNECTED)
  return { success: true, user }
}

export default makeSignup
